
export function disableContextMenuImages(wrapper = document){
    for (let img of wrapper.querySelectorAll('img,video')){
        img.addEventListener('contextmenu', function(e) {
            e.preventDefault();
        }, false);
    }
}